"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(props) {
  var hook = props.hook,
      onUpdate = props.onUpdate,
      namespace = props.namespace;
  var updateRef = (0, _react.useRef)(onUpdate);
  updateRef.current = onUpdate;
  var initialLoad = (0, _react.useRef)(false);
  var data;

  try {
    data = hook();

    if (process.env.NODE_ENV === 'development' && typeof document !== 'undefined') {
      var count = Object.keys((window._umi_useModel_dev_tool_log || {})[namespace] || {}).length;
      window._umi_useModel_dev_tool = _objectSpread(_objectSpread({}, window._umi_useModel_dev_tool), {}, _defineProperty({}, namespace, data));
      window._umi_useModel_dev_tool_log = _objectSpread(_objectSpread({}, window._umi_useModel_dev_tool_log), {}, _defineProperty({}, namespace, _objectSpread(_objectSpread({}, (window._umi_useModel_dev_tool_log || {})[namespace]), {}, _defineProperty({}, count, data))));
      window.dispatchEvent(new CustomEvent('_umi_useModel_update', {
        detail: {
          namespace: namespace,
          time: Date.now(),
          data: data,
          index: count
        }
      }));
    }
  } catch (e) {
    console.error("plugin-model: Invoking '".concat(namespace || 'unknown', "' model failed:"), e);
  } // 首次执行时立刻返回初始值


  (0, _react.useMemo)(function () {
    updateRef.current(data);
    initialLoad.current = false;
  }, []); // React 16.13 后 update 函数用 useEffect 包裹

  (0, _react.useEffect)(function () {
    if (initialLoad.current) {
      updateRef.current(data);
    } else {
      initialLoad.current = true;
    }
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

exports.default = _default;